<template>
    <div>
        <PageHeader :page_title="page_title"/>
        <pSpinner v-if="loading"></pSpinner>
        <template v-if="!loading">
            <v-layout>
                <v-container>
                    <v-card class="pl-4 pr-4 pb-4 pt-4">
                        <v-form ref="form" >
                            <v-container fluid>
                                <v-alert :value="alert_type" class="cyb-alert-success">{{alert_message}}<v-icon  @click = "alert_success = false" style="padding-bottom: 8px;float: right;font-size: 19.5px;font-weight: bold;line-height: 1;"  class="close_hover" >close</v-icon></v-alert> 
                            <v-layout row wrap calss="mt-4">
                                
                            <template calss="mt-4">
                                <v-flex xs12 sm6  md4>
                                  <v-text-field :type="show_password ? 'text' : 'password'" name="current_password" v-model="current_password" label="Current Password" ></v-text-field>
                                  <span  class="red--text mt-3" v-if="errors.current_password">{{errors.current_password[0]}}</span>
                                </v-flex>
                                
                                <v-flex xs12 sm6 md4>
                                  <v-text-field name="password" v-model="password" label="New Password"   :type="show_password ? 'text' : 'password'" :append-icon="show_password ? 'visibility' : 'visibility_off'" @click:append="show_password = !show_password" :rules="passwordRules"    v-on:keyup.enter="changePassword" required></v-text-field>
                                  <span  class="red--text mt-3" v-if="errors.password">{{errors.password[0]}}</span>
                                </v-flex>
                                <v-flex xs12 sm6 md4>
                                  <v-text-field :type="show_password ? 'text' : 'password'" name="password_confirm" v-model="password_confirm" label="Confirm Password" :rules="confirmPasswordRules" required v-on:keyup.enter="changePassword" ></v-text-field>
                                  <span  class="red--text " v-if="confirm_password">Password and confirm password should match</span>
                                </v-flex>
                                
                                <v-flex xs12 sm6 >
                                 <v-btn large color="primary" :disabled="!form_valid"  @click="changePassword">Update Password</v-btn>
                                </v-flex>
                            </template>
                            </v-layout>
                            </v-container>
                        </v-form>
                    </v-card>
                </v-container>
            </v-layout> 
        </template>
    </div>

</template>



<script>

  import axios from 'axios'

  import NoData from '@/components/NoData'
  
  import pSpinner from '@/components/pSpinner';
  
  import global from '@/components/rbconstants';
  
  import PageHeader from '@/components/PageHeader'
  
  import DepositMeta from '@/components/DepositMeta';
  
  export default {

    components : {

        NoData : NoData,
        
        PageHeader : PageHeader,
        
        DepositMeta : DepositMeta,
        
        pSpinner : pSpinner,
        
    },  
   
    mounted() {
        
    },
      
    data: () => ({
        
        page_title : "Change Password",
        
        password: '',
        
        current_password: '',
        
        password_confirm: '',
        
        alert_message: '',
        
        confirm_password: false,
        
        form_valid: true,
        
        loading : false,
        
        show_password: false,
        
        alert_type: false,
        
        alert_success : false,
        
        errors : [],
        
        passwordRules: [(v) => !!v || 'Password is required',   v => (v && v.length >= 6) || 'Password must have atleast 6 characters'],
        
        confirmPasswordRules: [(v) => !!v || 'Confirm password is required',   v => (v && v.length >= 6) || 'Confirm password must have atleast 6 characters'],  
        
    }),
    
	methods : {
	    
        changePassword: function() {
            
            var app = this
            
            if(this.$refs.form.validate()) {
                
                var isEqual = JSON.stringify(app.password) === JSON.stringify(app.password_confirm);    
                
                if(isEqual == false) {
                    
                    app.confirm_password = true
                    
                    app.form_valid = true
                    
                } else {
                
                    app.confirm_password = false
                    
                    axios.post(global.links.profile_change_password,  {
                        
                            current_password: app.current_password,
                      
                            password: app.password,
                            
                            password_confirmation: app.password_confirm,
                        
                        },{
           
                        headers: global.header
                        
                    })
         
                    .then(function(response) {
                       
                        if(response.status == 200) {
                            
                            app.errors = []
                            
                            app.alert_type = true
                           
                            app.alert_message = response.data.message
                           
                        }
                                        
                                      
                    })
                      
                    .catch(function(error) {
                      
                        if(error) {
                      
                            app.errors = error.response.data.errors
                       
                        }
                       
                      
                    })
                    
                }
            }
            
        }
        
	},

  }
  
</script>
<style scoped>

.cyb-alert-success {
    
   color: #3c763d  !important;
   border: 1px solid #d6e9c6 !important;
   border-radius: 4px !important;
   background-color: #dff0d8 !important;
   border-color: #d6e9c6 !important;
   
    padding-left: 16px !important;
    padding-bottom: 8px !important;
    margin-bottom: 8px !important;
}

</style>